/* eslint-disable max-statements */

/* eslint-disable react/react-in-jsx-scope */
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';
import { Menu } from 'primereact/menu';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import FeatureRequestBGImage from '../../../assets/FeatureRequestBGImage.png';
import delegateIcon from '../../../assets/delegateIcon.png';
import logoUrl from '../../../assets/empowerLogoBlue.png';
import userIcon from '../../../assets/userIcon.png';
import {
    AGENTROLE,
    COMPENSATION_SECURITY_GROUP,
    EDSDASHBOARD,
    EDS_SECURITY_GROUP,
    MANAGERDASHBOARD,
    MANAGERROLE,
    // MYMETRICS,
    ROLES,
    // SCORECARDDASHBOARD,
    SUPERVISORROLE,
    URL_ASKNOW_CREATE_TICKET,
    URL_ASKNOW_MY_RITMS,
    URL_ASKNOW_MY_INCIDENTS,
    MOOD_METER_CONFIG,
    COACHING_INSIGHTS_CONFIG,
    USE_COACHING_SKILLS_CONFIG,
    USE_COACHING_MODEL_DIMENSION_ID,
    // HOMEPAGE,
    LANDINGPAGE,
    UNAUTHORIZED,
    HIDE_GAMEPLAN_DIMENSION_ID,
    COMPENSATION,
    PRODUCTION_APP_ENVIRONMENT,
} from '../../../constants';
import { Delegate } from '../../../features/delegate/Delegate';
import { AboutMe } from '../../../features/header/aboutMe/AboutMe';
import { ApprovalCalendar } from '../../../features/header/approvalCalendar/ApprovalCalendar';
import { Notifications } from '../../../features/header/notifications/Notifications';
import { useGetEmployeeNotificationsQuery } from '../../../features/header/notifications/notificationSlice';
import { ProfileSection } from '../../../features/header/profileSection/ProfileSection';
import { useGetProfilePhotoQuery } from '../../../features/header/profilePhoto/profilePhotoSlice';
import { SignUpNotification } from '../../../features/header/signUpNotification/SignUpNotification';
import {
    selectCurrentEmpid,
    selectCurrentIsAdmin,
    // selectCurrentIsEds,
    selectCurrentRole,
    selectCurrentUser,
    selectCurrentUserEmail,
    selectCurrentUserManagerLevel,
    selectCurrentisComp,
    selectImpEmpid,
    selectImpIsAdmin,
    selectImpIsComp,
    selectImpIsEds,
    selectImpRole,
    selectImpUser,
    selectImpUserEmail,
    selectImpUserManagerLevel,
    selectIsDelegate,
    setCredentials,
    setIsUserMoodMeterHidden,
    setIsPseudoSupervisor,
    setIsAllowCoachingInsight,
    setIsAllowCoachingActionModel,
    setIsUseCoachingSkills,
    setMgrEmpId,
    setIsUserinPercepta,
    setUserParentClient,
    setIsManagerRecentApprover,
} from '../../../pages/login/authSlice';
import { CorrectiveActionsToast } from '../../correctiveActionsToast/CorrectiveActionsToast';
import { DelegateToast } from '../../delegateToast/DelegateToast';
import { FeatureRequest } from '../../featureRequest/FeatureRequest';
import { ReportProblem } from '../../reportProblem/ReportProblem';
import './Header.css';
import { useGetUserReporteesCountQuery } from '../../../pages/impersonate/impersonateSlice';
import { useGetAllConfigSwitchesForEmployeeQuery } from '../../coachingInsight/CoachingInsightSlice';
import { ApprovalWindowNotificationToast } from '../../approvalWindowNotificationToast/ApprovalWindowNotificationToast';
import { useGetAboutMePersonalizationQuery } from '../../../features/header/aboutMe/aboutMeSlice';
import { useGetParentClientQuery } from '../../../features/coaching/coachingSlice';
import { removeLocalStorageExceptKeys } from '../../../utils/clearLocalStorageKeys';
import { useGetManagerRecentApprovalsCountQuery } from '../../../pages/managerDashboard/managerDashboardSlice';

const openFAQPDF = (filename: string) => {
    window.open(`${process.env.PUBLIC_URL}/${filename}.pdf`, '_blank');
};

// Function to create a FAQ command
const createFaqCommand = (filename: string) => () => openFAQPDF(filename);

export const Header = () => {
    const dispatch = useDispatch();
    const role = useSelector(selectCurrentRole);
    const op = useRef<OverlayPanel>(null);
    const openProfile = useRef<OverlayPanel>(null);
    const menu = useRef<Menu>(null);
    const impUser = useSelector(selectImpUser);
    const impUserEmail = useSelector(selectImpUserEmail);
    const impRole = useSelector(selectImpRole);
    const impEds = useSelector(selectImpIsEds);
    const impAdmin = useSelector(selectImpIsAdmin);
    const impEmpId = useSelector(selectImpEmpid);
    const impComp = useSelector(selectImpIsComp);
    // const isEds = useSelector(selectCurrentIsEds);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isComp = useSelector(selectCurrentisComp);
    const impUserManagerLevel = useSelector(selectImpUserManagerLevel);
    const isDelegate = useSelector(selectIsDelegate);
    const navigate = useNavigate();
    const [userImpersonate, setUserImpersonate] = useState<boolean>(false);
    const items = [];
    const faqs = { label: 'FAQs', icon: 'faq', items: [] as any };
    const loggedUser = useSelector(selectCurrentUser);
    const loggedUserEmail = useSelector(selectCurrentUserEmail);

    const { data: profilePhotoBase64 } = useGetProfilePhotoQuery(
        { email: loggedUserEmail },
        { skip: !loggedUserEmail, refetchOnMountOrArgChange: false }
    );
    const profilePhotoUrl = profilePhotoBase64 ? `data:image/jpeg;base64,${profilePhotoBase64}` : null;

    const [reportProblem, setReportProblem] = useState(false);
    const [delegateModal, setDelegateModal] = useState(false);
    const [featureRequest, setFeatureRequest] = useState(false);
    const [visibleFeatureRequest, setVisibleFeatureRequest] = useState(false);
    const [visibleAboutMe, setVisibleAboutMe] = useState(false);
    const [visibleApprovalCalendar, setVisibleApprovalCalendar] = useState(false);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [notifications, setNotifications] = useState<any>();
    const [notificationCount, setNotificationCount] = useState<number>(0);
    const [visibleSignUpNotification, setVisibleSignUpNotification] = useState(false);
    const [isUserRecentApprover, setIsUserRecentApprover] = useState<boolean>(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);

    const { data: aboutMeData } = useGetAboutMePersonalizationQuery(
        { employeeNumber: loggedEmpNum },
        { skip: !loggedEmpNum }
    );

    const { data: employeeNotifications } = useGetEmployeeNotificationsQuery(
        { employeeNumber: loggedEmpNum },
        { skip: !loggedEmpNum }
    );

    const { data: userReporteesCount } = useGetUserReporteesCountQuery(
        {
            employeeNumber: loggedEmpNum,
        },
        {
            skip: !loggedEmpNum || !ROLES.Agents.includes(userManagerLevel),
        }
    );

    // Fetch all config switches in a single call
    const { data: allConfigSwitches } = useGetAllConfigSwitchesForEmployeeQuery(
        loggedEmpNum,
        {
            skip: !loggedEmpNum,
        }
    );

    // Extract individual config values from the batch response
    const ShowCoachingInsightsSlice = allConfigSwitches?.data?.[COACHING_INSIGHTS_CONFIG];
    const HideMoodMeter = allConfigSwitches?.data?.[MOOD_METER_CONFIG];
    const useCoachingSkillsData = allConfigSwitches?.data?.[USE_COACHING_SKILLS_CONFIG];
    const useCoachingActionModelData = allConfigSwitches?.data?.[USE_COACHING_MODEL_DIMENSION_ID];
    const hideGameplanDimensionId = allConfigSwitches?.data?.[HIDE_GAMEPLAN_DIMENSION_ID];

    const { data: loggedUserParentClient } = useGetParentClientQuery(
        {
            employeeNumber: loggedEmpNum,
        },
        {
            skip: !loggedEmpNum,
        }
    );

    const { data: employeeRecentApproverStatus,isLoading: isRecentApproverLoading,
    isFetching: isRecentApproverFetching } = useGetManagerRecentApprovalsCountQuery(
        { employeeNumber: loggedEmpNum },
        {
            skip: !loggedEmpNum || !ROLES.Manager.includes(userManagerLevel),
        }
    );
    useEffect(() => {
        if (loggedUserParentClient?.data.length > 0) {
            const parentClient = [loggedUserParentClient?.data[0].parent_client_id];
            dispatch(setUserParentClient(parentClient));
        }
    }, [loggedUserParentClient]);

    useEffect(() => {
        if (userReporteesCount?.status && userReporteesCount?.data > 0) {
            dispatch(setIsPseudoSupervisor(true));
        } else {
            dispatch(setIsPseudoSupervisor(false));
        }
    }, [userReporteesCount]);

    useEffect(() => {
        if (ShowCoachingInsightsSlice === true) {
            dispatch(setIsAllowCoachingInsight(true));
        } else {
            dispatch(setIsAllowCoachingInsight(false));
        }
    }, [ShowCoachingInsightsSlice]);

    useEffect(() => {
        if (HideMoodMeter === true) {
            dispatch(setIsUserMoodMeterHidden(true));
        } else {
            dispatch(setIsUserMoodMeterHidden(false));
        }
    }, [HideMoodMeter]);

    useEffect(() => {
        if (useCoachingSkillsData === true) {
            dispatch(setIsUseCoachingSkills(true));
        } else {
            dispatch(setIsUseCoachingSkills(false));
        }
    }, [useCoachingSkillsData]);

    useEffect(() => {
        if (useCoachingActionModelData === true) {
            dispatch(setIsAllowCoachingActionModel(true));
        } else {
            dispatch(setIsAllowCoachingActionModel(false));
        }
    }, [useCoachingActionModelData]);

    useEffect(() => {
        if (hideGameplanDimensionId === true) {
            dispatch(setIsUserinPercepta(true));
        } else {
            dispatch(setIsUserinPercepta(false));
        }
    }, [hideGameplanDimensionId]);

    useEffect(() => {
        if (isRecentApproverLoading || isRecentApproverFetching) return;
        if ((employeeRecentApproverStatus?.status && employeeRecentApproverStatus?.data === true)) {
            setIsUserRecentApprover(true);
            dispatch(setIsManagerRecentApprover(true));
        } else {
            setIsUserRecentApprover(false);
            dispatch(setIsManagerRecentApprover(false));
        }
    }, [employeeRecentApproverStatus]);

    useEffect(() => {
        if (employeeNotifications?.data?.length > 0) {
            setNotifications(employeeNotifications.data);
            setNotificationCount(employeeNotifications.data[0].unread_count);
        } else {
            setNotificationCount(0);
            setNotifications([]);
        }
    }, [employeeNotifications]);

    useEffect(() => {
        if (aboutMeData?.data.length > 0) {
            dispatch(setMgrEmpId(aboutMeData?.data[0]?.manager_number));
        }
    }, [aboutMeData]);

    const onAboutMeHide = () => {
        setVisibleAboutMe(false);
    };

    const onSignUpNotificationHide = () => {
        setVisibleSignUpNotification(false);
    };

    const onApprovalCalendarHide = () => {
        setVisibleApprovalCalendar(false);
    };

    const dialogFuncMap = {
        reportProblem: setReportProblem,
        delegateModal: setDelegateModal,
        featureRequest: setFeatureRequest,
    };

    const onReportProblemHide = () => {
        dialogFuncMap.reportProblem(false);
    };
    const onFeatureRequestHide = () => {
        dialogFuncMap.featureRequest(false);
    };

    const onDelegateHide = () => {
        dialogFuncMap.delegateModal(false);
    };

    // if (!isComp && !isEds && !isAdmin) {
    if (!isComp && !isAdmin && !ROLES.Agents.includes(userManagerLevel)) {
        if (!isDelegate && !userImpersonate) {
            items.push({
                label: 'Delegate',
                icon: 'delegate',
                command: () => dialogFuncMap.delegateModal(true),
            });
        }
        if (!isDelegate && userImpersonate && impAdmin) {
            items.push({
                label: 'Delegate',
                icon: 'delegate',
                command: () => dialogFuncMap.delegateModal(true),
            });
        }
    }
    if (
        (process.env.REACT_APP_ENVIRONMENT === PRODUCTION_APP_ENVIRONMENT ? impAdmin : true) &&
        !userImpersonate &&
        !isDelegate
    ) {
        items.push({ label: 'Impersonate', icon: 'delegate', command: () => navigate(`/impersonate`) });
    }

    // items.unshift({
    //     label: 'Report a problem',
    //     icon: 'reportProblem',
    //     command: () => {
    //         dialogFuncMap.reportProblem(true);
    //     },
    // });
    // items.unshift({
    //     label: 'Feature Request',
    //     icon: 'requestFeature',
    //     command: () => {
    //         dialogFuncMap.featureRequest(true);
    //     },
    // });
    if (
        userImpersonate &&
        (process.env.REACT_APP_ENVIRONMENT === PRODUCTION_APP_ENVIRONMENT ? impAdmin : true) &&
        !isDelegate
    ) {
        items.push({
            label: 'Exit Impersonate Mode',
            icon: 'delegate',
            command: () => exitImpersonateMode(),
        });
    }
    if (userImpersonate && isDelegate) {
        items.push({
            label: 'Exit Delegate Mode',
            icon: 'delegate',
            command: () => exitImpersonateMode(),
        });
    }
    items.push({ separator: true });
    items.push({
        label: 'AskNow Ticket',
        icon: 'AskNowTicket',
        items: [
            {
                label: 'Create Ticket',
                icon: 'pi pi-fw pi-external-link',
                command: () => window.open(URL_ASKNOW_CREATE_TICKET, '_blank'),
            },
            {
                label: 'My Requests',
                icon: 'pi pi-fw pi-external-link',
                command: () => window.open(URL_ASKNOW_MY_RITMS, '_blank'),
            },
            {
                label: 'My Incidents',
                icon: 'pi pi-fw pi-external-link',
                command: () => window.open(URL_ASKNOW_MY_INCIDENTS, '_blank'),
            },
        ],
    });
    useEffect(() => {
        setUserImpersonate(window.localStorage.isUserImpersonate === 'true');
    }, [window.localStorage.isUserImpersonate]);

    useEffect(() => {
        if (isDelegate) {
            dialogFuncMap.delegateModal(false);
        }
    }, [isDelegate]);
    // Define roleFAQs using the createFaqCommand function
    const roleFAQs = [
        { role: AGENTROLE, label: 'Program FAQs', icon: 'faq', command: createFaqCommand('Program_FAQ') },
        { role: AGENTROLE, label: 'Associate FAQs', icon: 'faq', command: createFaqCommand('Associate_FAQ') },
        { role: MANAGERROLE, label: 'Manager FAQs', icon: 'faq', command: createFaqCommand('Manager_FAQ') },
        {
            role: SUPERVISORROLE,
            label: 'Team Lead FAQs',
            icon: 'faq',
            command: createFaqCommand('TeamLead_FAQ'),
        },
        { role: EDS_SECURITY_GROUP, label: 'EDS FAQs', icon: 'faq', command: createFaqCommand('EDS_FAQ') },
        {
            role: COMPENSATION_SECURITY_GROUP,
            label: 'Compensation FAQs',
            icon: 'faq',
            command: createFaqCommand('Comp_FAQ'),
        },
    ];

    if (roleFAQs.some((roleFAQ) => roleFAQ.role === role)) {
        items.push({ separator: true });

        const relevantFAQs = roleFAQs.filter((roleFAQ) => roleFAQ.role === role);
        faqs.items.push(...relevantFAQs);

        items.push(faqs);
    }

    const exitImpersonateMode = () => {
        const userobj = {
            empid: impEmpId,
            user: impUser,
            email: impUserEmail,
            role: impRole,
            userManagerLevel: impUserManagerLevel,
            isAdmin: impAdmin,
            isEds: impEds,
            isComp: impComp,
        };

        dispatch(setCredentials(userobj));

        removeLocalStorageExceptKeys(['isUserImpersonate']);
        // removeSelectedLocalStorageKeys(['SCfilDate']);
        window.localStorage.isUserImpersonate = 'false';

        if (isDelegate) {
            toast.success('You have exited Delegation mode');
        }

        let route;

        if ((impRole === AGENTROLE || impRole === SUPERVISORROLE) && !impEds && !impComp) {
            route = LANDINGPAGE;
        } else if (impRole === MANAGERROLE && isUserRecentApprover) {
            route = LANDINGPAGE;  // MANAGERDASHBOARD;
        } else if (impRole === MANAGERROLE && !isUserRecentApprover) {
            route = MANAGERDASHBOARD;
        }
        else if (!impAdmin) {
            if (impEds) {
                route = EDSDASHBOARD;
            } else if (impComp) {
                route = COMPENSATION;
            } else {
                route = UNAUTHORIZED;
            }
        } else {
            route = UNAUTHORIZED;
        }

        navigate(route, route === UNAUTHORIZED ? { replace: true } : undefined);
    };

    const popupMenuClickHandler = (e: any) => {
        e.preventDefault();
        menu.current?.toggle(e);
    };
    const validRoles = [SUPERVISORROLE, AGENTROLE, MANAGERROLE];

    const delegateHeader = () => {
        return (
            <h5 className="mb-3" style={{ fontSize: '24px' }}>
                <img src={delegateIcon} alt="Delegate" className="pe-2" /> Delegate
            </h5>
        );
    };

    return (
        <div className="root-layout">
            {<CorrectiveActionsToast />}
            {<ApprovalWindowNotificationToast />}
            {!isDelegate ? <DelegateToast /> : ''}

            {validRoles.includes(role) ? (
                <header className="py-2 text-bg-light border-bottom shadow">
                    <nav>
                        <h1>
                            <img className="justify-content-left logo ps-4" src={logoUrl} alt="Empower" />
                        </h1>
                        {/* NOT PRODUCTION READY */}

                        <div
                            onClick={(e) => {
                                window.localStorage.notificationId = 0;
                                op.current?.toggle(e);
                            }}
                            aria-hidden="true"
                            className="headerNotification"
                        >
                            <i
                                className="pi pi-envelope p-text-secondary p-overlay-badge mt-4 me-2"
                                style={{ fontSize: '1.2rem' }}
                            >
                                <Badge value={notificationCount}>
                                    <i
                                        className="pi pi-envelope p-text-secondary p-overlay-badge mt-4 me-2"
                                        style={{ fontSize: '1.2rem' }}
                                    />
                                </Badge>
                            </i>
                        </div>

                        <div
                            onClick={(e: any) => popupMenuClickHandler(e)}
                            aria-controls="popup_menu"
                            aria-haspopup
                            aria-hidden="true"
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="pi pi-ellipsis-v mt-4" style={{ fontSize: '1.2em' }} />
                        </div>
                        <div
                            onClick={(e) => openProfile.current?.toggle(e)}
                            aria-haspopup
                            aria-hidden="true"
                            style={{ cursor: 'pointer' }}
                        >
                            <img
                                className="justify-content-left mt-3 me-4"
                                src={profilePhotoUrl || userIcon}
                                width={36}
                                height={36}
                                style={{ objectFit: 'cover', borderRadius: '50%' }}
                                alt="User"
                            />
                        </div>

                        <OverlayPanel
                            ref={op}
                            id="overlay_panel"
                            style={{ width: '800px', borderRadius: '8px' }}
                            className="overlaypanel-demo"
                            showCloseIcon
                        >
                            <h6
                                className="border-bottom pb-3"
                                style={{ fontSize: '18px', fontWeight: '700', color: '#3F5765' }}
                            >
                                Notifications
                            </h6>

                            <Notifications employeeNumber={loggedEmpNum} notification={notifications} />
                        </OverlayPanel>

                        <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />

                        <OverlayPanel
                            ref={openProfile}
                            id="overlay_panel"
                            style={{ width: '280px', borderRadius: '8px', marginTop: '0px' }}
                            className="overlaypanel-demo"
                            showCloseIcon={false}
                        >
                            <ProfileSection
                                setVisibleAboutMe={(value) => {
                                    openProfile?.current?.hide();
                                    setVisibleAboutMe(value);
                                }}
                                setVisibleSignUpNotification={(value) => {
                                    openProfile?.current?.hide();
                                    setVisibleSignUpNotification(value);
                                }}
                                setVisibleApprovalCalendar={(value) => {
                                    openProfile?.current?.hide();
                                    setVisibleApprovalCalendar(value);
                                }}
                            />
                        </OverlayPanel>
                    </nav>
                </header>
            ) : (
                ''
            )}

            <Dialog
                visible={visibleAboutMe}
                style={{ width: '40vw', borderRadius: '12px' }}
                onHide={onAboutMeHide}
            >
                <AboutMe hideFunction={onAboutMeHide} loggedUser={loggedUser} />
            </Dialog>
            <Dialog
                id="signUpNotification"
                visible={visibleSignUpNotification}
                style={{ width: '43vw', borderRadius: '12px' }}
                onHide={onSignUpNotificationHide}
            >
                <SignUpNotification />
            </Dialog>
            <Dialog
                id="approvalCalendar"
                visible={visibleApprovalCalendar && impEmpId}
                style={{ width: '790px', borderRadius: '12px' }}
                onHide={onApprovalCalendarHide}
            >
                <ApprovalCalendar />
            </Dialog>
            <Dialog
                /* header="Report a problem" */
                visible={reportProblem}
                style={{ width: '40vw', borderRadius: '12px' }}
                onHide={() => onReportProblemHide()}
                className="reportProblemDialog"
            >
                <ReportProblem hideFunction={onReportProblemHide} />
            </Dialog>
            <Dialog
                /* header="Report a problem" */
                visible={featureRequest}
                style={{ width: '40vw', borderRadius: '12px' }}
                onHide={() => onFeatureRequestHide()}
                className="reportProblemDialog"
            >
                <FeatureRequest
                    hideFunction={onFeatureRequestHide}
                    setVisibleFeatureRequest={setVisibleFeatureRequest}
                />
            </Dialog>

            <span />

            <Dialog
                visible={delegateModal}
                onHide={() => onDelegateHide()}
                className="w-50"
                header={delegateHeader}
            >
                <Delegate index={0} />
            </Dialog>

            <Dialog
                header="Feature Request"
                visible={visibleFeatureRequest}
                style={{ width: '20vw' }}
                onHide={() => setVisibleFeatureRequest(false)}
            >
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h3 className="mx-auto d-block mb-4" style={{ fontWeight: 700 }}>
                            Thanks for your input! <br /> We’ve received your request.
                        </h3>
                        <hr />
                        <img
                            src={FeatureRequestBGImage}
                            alt="Add Feature"
                            className="img-fluid mx-auto d-block mb-4"
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
